// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lng8","question":"styles_question__1ThGr","description":"styles_description__39NjF"};